module.exports = __webpack_public_path__ + "img/limit_time_gift.d24d5ec8.png";